export const emptyOrg = {
    _id: '',
    name: ''
}

export interface Org {
    _id: string,
    name: string
}
